import { NgModule , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ProductThumbnailComponent } from './components/product-thumbnail/product-thumbnail.component';
import { ToastrModule } from 'ngx-toastr';
import { NgbPaginationModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2CompleterModule } from "ng2-completer";
import { ProductListModalComponent } from './modals/product-list-modal/product-list-modal.component';
import { ProductListComponent } from '../modules/product/pages/product-list/product-list.component';
import { MatTableModule } from '@angular/material/table';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import {  ErrorStateMatcher, MatNativeDateModule } from '@angular/material/core';
import { CustomErrorStateMatcher } from './services/custom-error-state';
import { CartListModalComponent } from './modals/cart-list-modal/cart-list-modal.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { MatRadioModule } from '@angular/material/radio';
import { AddressCreateEditModalComponent } from './modals/address-create-edit-modal/address-create-edit-modal.component';
import { ChartsModule } from 'ng2-charts';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule }  from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DeleteCartItemModalComponent } from './modals/delete-cart-item-modal/delete-cart-item-modal.component';
import { CreateOrderFormComponent } from './components/create-order-form/create-order-form.component';
import { OrderDetailsContentComponent } from './components/order-details-content/order-details-content.component';
import { SortIconComponent } from './components/sort-icon/sort-icon.component';
import { LoginPromptModalComponent } from './modals/login-prompt-modal/login-prompt-modal.component';
import { ConfirmationModalComponent } from './modals/confirmation-modal/confirmation-modal.component';
import { AddressSelectorModalComponent } from './modals/address-selector-modal/address-selector-modal.component';
import { ProcessToOrderModalComponent } from './modals/process-to-order-modal/process-to-order-modal.component';
import { AddressSelectorComponent } from './components/address-selector/address-selector.component';
import { ImageCircleComponent } from './components/image-circle/image-circle.component';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { ButtonLoadingComponent } from './components/button-loading/button-loading.component';
import { ChangeEmailModalComponent } from './modals/change-email-modal/change-email-modal.component';
import { ChangePasswordModalComponent } from './modals/change-password-modal/change-password-modal.component';
import { SignOutComponent } from './components/sign-out/sign-out.component';
import { CustomerOrdersListComponent } from './components/customer-orders-list/customer-orders-list.component';
import { CustomerQuotesListComponent } from './components/customer-quotes-list/customer-quotes-list.component';
import { OrderDetailModalComponent } from './modals/order-detail-modal/order-detail-modal.component';
import { CreateOrderForm2Component } from './components/create-order-form2/create-order-form2.component';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  declarations: [SpinnerComponent, ProductThumbnailComponent, ProductListModalComponent, ProductListComponent, CartListModalComponent, AddressCreateEditModalComponent, DeleteCartItemModalComponent, CreateOrderFormComponent, OrderDetailsContentComponent, SortIconComponent, LoginPromptModalComponent, ConfirmationModalComponent, AddressSelectorModalComponent, ProcessToOrderModalComponent, AddressSelectorComponent, ImageCircleComponent, ErrorMessageComponent, ButtonLoadingComponent, ChangeEmailModalComponent, ChangePasswordModalComponent, SignOutComponent, CustomerOrdersListComponent, CustomerQuotesListComponent, OrderDetailModalComponent, CreateOrderForm2Component],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ToastrModule.forRoot({ timeOut: 4000, closeButton: true }),
    NgbPaginationModule,
    NgbTypeaheadModule,
    Ng2CompleterModule,
    NgxSliderModule,
    ChartsModule ,
    //Mat Modules
    MatTableModule,
    MatExpansionModule,
    MatInputModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDividerModule,
    MatListModule,
    MatCardModule,
    MatCheckboxModule,
    MatSelectModule,    
  ],
  exports: [
    //Modules
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ToastrModule,
    NgbPaginationModule,
    NgbTypeaheadModule,
    Ng2CompleterModule,
    NgxSliderModule,
    MatTableModule,
    MatExpansionModule,
    MatInputModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDividerModule,
    ChartsModule ,
    MatListModule,
    MatCardModule,
    MatCheckboxModule,
    MatSelectModule,
    //Components
    SpinnerComponent,
    ProductThumbnailComponent,
    ProductListComponent,
    CreateOrderFormComponent,
    CreateOrderForm2Component,
    OrderDetailsContentComponent,
    SortIconComponent,
    ImageCircleComponent,
    ErrorMessageComponent,
    ButtonLoadingComponent,
    ChangeEmailModalComponent,
    ChangePasswordModalComponent,
    SignOutComponent,
    CustomerOrdersListComponent,
    CustomerQuotesListComponent
  ],
  entryComponents: [ProductListModalComponent, CartListModalComponent, AddressCreateEditModalComponent, DeleteCartItemModalComponent, CreateOrderFormComponent, ConfirmationModalComponent, AddressSelectorModalComponent, ProcessToOrderModalComponent, OrderDetailModalComponent, CreateOrderForm2Component],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: ErrorStateMatcher, useClass: CustomErrorStateMatcher }
  ]
})
export class SharedModule { }
